import _ from 'lodash';

import { createApiCall } from '../createApiCall';
import { StartAction, SuccessAction, FailureAction } from './types';

import { ApiConfig } from '../types';

type StartActionFn = () => StartAction;
type SuccessActionFn = (data: any) => SuccessAction;
type FailureActionFn = (data: any) => FailureAction;

/**
 * Function which creates a thunk action for given api config and associated action types
 * @param {string|Object} apiConfig if string it is interprated as path in api endpoint
 * @param {string} apiConfig.hostname hostname of the api, with a default values set in '../config'
 * @param {string} apiConfig.path path on the hostname which combined give an api endpoint
 * @param {string} apiConfig.method HTTP request method, defaults to 'GET'
 * @param {Object} apiConfig.headers headers to be used in HTTP request
 */
export const createApiAction = (
  apiConfig: ApiConfig,
  startAction: StartActionFn,
  successAction: SuccessActionFn,
  failureAction: FailureActionFn
) => async (dispatch: any) => {
  const apiCall = createApiCall(apiConfig);

  dispatch(startAction());

  try {
    const response = await apiCall();

    let res;
    const additionalData = apiConfig.additionalData || {};

    if (!_.isEmpty(additionalData)) {
      res = await dispatch(
        successAction({ ...response.data, ...additionalData })
      );
    } else {
      res = await dispatch(successAction(response.data));
    }

    return { ok: true, res };
  } catch (e: any) {
    const error = _.get(e, 'response.data', {
      errorMessage: e.message || 'Undefined error, please try again.',
    });

    console.error(e);

    await dispatch(
      failureAction({
        message: error.errorMessage,
      })
    );

    return {
      ok: false,
      errorMessage: error.errorMessage,
    };
  }
};
